exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table td[data-v-90552d54] {\n  border-top: none !important;\n}\n.v-aligin-top[data-v-90552d54] {\n  vertical-align: top !important;\n}\n.subsection-heading[data-v-90552d54] {\n  font-weight: bold;\n}\n.mt-10[data-v-90552d54] {\n  margin-top: 10px;\n}\n", ""]);

// exports
